@if ((appService.pageLoading$ | async) || (appService.loading$ | async)) {
  <div class="load-panel__overlay">
  </div>
}
<div class="load-panel__content" aria-live="assertive" [cdkTrapFocus]="(appService.pageLoading$ | async) || (appService.loading$ | async)">
  <mat-spinner diameter="32"></mat-spinner>
  <p #loader [tabindex]="(appService.pageLoading$ | async) || (appService.loading$ | async) ? 0 : -1">{{(appService.loading$ | async) ? appService.loadingMessage : (appService.pageLoading$ | async) ? appService.pageLoadingMessage : loadedMessage}}</p>
</div>
